import { Injectable } from '@angular/core';
import { PollyManageDataService } from './polly-manage-data-service/polly-manage-data.service';
import { UserResponse } from 'polly-commons';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { PollyManageBackendService } from './polly-manage-backend-service/polly-manage-backend.service';

@Injectable({
  providedIn: 'root'
})
export class PollyManageUserDataGuardService {

  constructor(
    private readonly manageDataService: PollyManageDataService,
    private readonly pollyManageBackendService: PollyManageBackendService
  ) { }

  public canActivate(): Observable<boolean> {
    const currentUserInfo: UserResponse = this.manageDataService.getUserInfo() as UserResponse;
    if (currentUserInfo) {
      return of(true);
    } else {
      return this.pollyManageBackendService.getCurrentUserInfo().pipe(
        map((userInfo: UserResponse) => {
          this.manageDataService.userInfo = userInfo;
          this.manageDataService.currentUserInfo = userInfo.data;
          if (userInfo.included && userInfo.included.length) {
            const orgInfo = userInfo.included.find(item => item.type === 'organizations');
            if (orgInfo) {
              this.manageDataService.currentUserOrganization = {
                org_id: Number(orgInfo.id),
                org_name: orgInfo.attributes.name
              };
            }
          }
          return true;
        })
      );
    }
  }
}